// Fetch geocode data from backend

import axios from "axios";
import { getAuthToken } from "../utils/auth";

const baseUrl = `${
  process.env.REACT_APP_API_BASE_URL || "https://pro.vibelinksapp.com/api"
}`;

export const getAppSettings = async (params = {}) => {
  const token = await getAuthToken();
  
  // Return null if no token to avoid unnecessary network requests
  if (!token) {
    return null;
  }
  
  const response = await axios.get(`${baseUrl}/app-settings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  });

  return response?.data?.data;
};

export const getBlockUser = async (params = {}) => {
  const token = getAuthToken();

  const response = await axios.get(`${baseUrl}/get-blocked-user`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  });


  return response?.data?.data;
};

export const changePassword = async (passwordData) => {
  const token = getAuthToken();

  const response = await axios.post(
    `${baseUrl}/change-password`,
    passwordData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );


  return response?.data;
};

export const getAddresses = async () => {
  const token = getAuthToken();

  const response = await axios.post(
    `${baseUrl}/get-address`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );


  return response?.data?.data;
};

export const addUpdateAddress = async (addressData) => {
  const token = getAuthToken();
  const formData = new FormData();
  // Map frontend fields to API fields
  formData.append("type", addressData.type || "Home");
  formData.append("address_line_1", addressData.address || "");
  formData.append("city", addressData.city || "");
  formData.append("state", addressData.state || "");
  formData.append("country", addressData.country || "");
  formData.append("zip", addressData.postalCode || addressData.zip || "");
  if (addressData.id) {
    formData.append("address_id", addressData.id);
  }
  const response = await axios.post(`${baseUrl}/add-update-address`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return response?.data;
};

export const blockUnblockUser = async (userId) => {
  const token = getAuthToken();

  const response = await axios.post(
    `${baseUrl}/block-unblock-user`,
    {
      user_id: userId,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );


  return response?.data;
};

export const uploadToS3 = async (file) => {
  const token = getAuthToken();

  const formData = new FormData();
  formData.append("image", file);

  try {

    const response = await axios.post(`${baseUrl}/s3-upload`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });


    return response?.data;
  } catch (error) {
    throw error;
  }
};
// Fetch live streaming users
export const getLiveStreamingUsers = async () => {
  const token = getAuthToken();
  try {
    const response = await axios.post(`${baseUrl}/live-streaming-users`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const updateProfile = async (profileData) => {
  const token = getAuthToken();

  const response = await axios.post(`${baseUrl}/update-profile`, profileData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });


  return response?.data;
};

export const getProfile = async (formData) => {
  const token = getAuthToken();
  const response = await axios.get(`${baseUrl}/get-profile`, {
    params: formData, // send as query params
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response?.data;
};

export const deleteAddress = async (addressId) => {
  const formData = new FormData();
  formData.append("address_id", addressId);
  try {
    const response = await axios.post(`${baseUrl}/delete-address`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

// User registration API call
export const signupUser = async (formData) => {
  try {
    const response = await axios.post(`${baseUrl}/signup`, formData, {
      headers: {
        "Accept-Language": "en",
      },
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};
// Delete address by ID

// Delete user account
export const deleteAccount = async () => {
  const token = getAuthToken();
  try {
    const response = await axios.post(
      `${baseUrl}/delete-account`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const fetchGeocodeData = async (placeId) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/geocode-address`,
      { place_id: placeId }
    );
    if (response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch geocode data",
      };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "An error occurred while fetching geocode data",
    };
  }
};
export const followUnfollowUser = async (formData) => {
  const token = getAuthToken();
  try {
    const response = await axios.post(`${baseUrl}/follow-unfollow`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const createSubscriptionUrl = async (formData) => {
  const token = getAuthToken();
  try {
    const response = await axios.post(
      `${baseUrl}/subscription/create-session`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getSubscriptionStripeStatus = async () => {
  const token = getAuthToken();
  const response = await axios.get(`${baseUrl}/subscription/latest`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getSubscriptionStripeHistory = async () => {
  const token = getAuthToken();
  const response = await axios.post(
    `${baseUrl}/subscription/portal`, // URL
    {}, // request body (empty object here)
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const cancelSubscriptionStripe = async () => {
  const token = getAuthToken();
  const response = await axios.post(
    `${baseUrl}/subscription/cancel`, // URL
    {}, // request body (empty object here)
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
